/**
 * Created by strunz on 05.05.2017.
 */
export class OptionItem {

    id:number;
    label:string;
    subItems:OptionItem[]=Array();
    active:boolean=false;
    disabled:boolean=false;
    count:number=0;

    constructor(optionItemData){
        this.id = optionItemData.id;
        this.label = optionItemData.label;
        if(optionItemData.active) {
            this.active = optionItemData.active;
        }
        for (let subItem in optionItemData.subItems) {
            this.subItems.push(new OptionItem(optionItemData.subItems[subItem]));
        }
    }

    getAllItems(result:OptionItem[]):OptionItem[]{
        if(this.subItems.length==0){
            result.push(this);
            return result;
        }else {
            for (let subItem in this.subItems) {
                result = this.subItems[subItem].getAllItems(result);
            }
        }
        return result;
    }
    getSelectedItems(result:OptionItem[]):OptionItem[]{
        if(this.active){
            result.push(this);
            return result;
        }
        for (let subItem in this.subItems) {
            result = this.subItems[subItem].getSelectedItems(result);
        }
        return result;
    }
}